export const getPalletMultiplier = (is_palletized: boolean | null | undefined, pallet_count: number): number =>
  is_palletized ? pallet_count : 1;
